module.exports = __webpack_public_path__ + "media/images/area/area_chugokuM400-a3582f2600fc68cc143395eaaa50508e.jpg";